import * as React from "react";
import { createComponent } from "@lit/react";
import Component from "../../components/Drawer/sgds-drawer";
import { register } from "../../utils/ce-registry";

register("sgds-drawer", Component);

export default createComponent({
  react: React,
  tagName: "sgds-drawer",
  elementClass: Component,
  events: {
    onSgdsShow: "sgds-show",
    onSgdsAfterShow: "sgds-after-show",
    onSgdsHide: "sgds-hide",
    onSgdsAfterHide: "sgds-after-hide",
    onSgdsInitialFocus: "sgds-initial-focus",
    onSgdsRequestClose: "sgds-request-close"
  }
});
